/** « Joseph vit encore ! » → « joseph-vit-encore » (utilisé dans l'adresse de la page). */
export const slugifier = (texte: string) =>
  texte
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60)

/** Identifiant lisible et unique parmi `existants` (ajoute -2, -3… si besoin). */
export const nouvelIdentifiant = (base: string, existants: string[]) => {
  const racine = slugifier(base) || Date.now().toString(36)
  let id = racine
  for (let i = 2; existants.includes(id); i++) id = `${racine}-${i}`
  return id
}
